import { get } from 'svelte/store';
import { toast } from '@Shelly/shelly-design-system';
import { format } from 'svelte-i18n';
import { postReq } from '../../../../services/http';
import { user_settings } from 'src/stores/account/user';

const _format = get(format);

// PUSH Permissions ----------------------------------------------------------------------
export const handlePushPermissions = async (checked) => {
	let res = await postReq('/user/set_push_notifications_permissions', {
		permissions: checked,
	});
	if (res.isok) {
		user_settings.update((settings) => {
			settings.push_notifications_permissions = checked ? 1 : 0;
			return settings;
		});
		toast.open({ type: 'success', title: _format('setting_scc_saved_toast') });
	} else {
		toast.open({ type: 'danger', title: 'error_global' });
	}
};

// EMAIL Permissions ----------------------------------------------------------------------
export const handleEmailPermissions = async (checked) => {
	let res = await postReq('/user/set_mail_notifications_permissions', {
		permissions: checked,
	});
	if (res.isok) {
		toast.open({ type: 'success', title: _format('setting_scc_saved_toast') });
		user_settings.update((settings) => {
			settings.mail_notifications_permissions = checked;
			return settings;
		});
	} else {
		toast.open({ type: 'danger', title: 'error_global' });
	}
};

// NEWSLETTER Permissions ----------------------------------------------------------------------
export const handleNewsLetterPermissions = async (checked) => {
	let res = await postReq('/user/set_newsletter', {
		set: checked ? 1 : 0,
	});
	if (res.isok) {
		if (checked) {
			toast.open({
				type: 'success',
				title: _format('setting_scc_saved_toast'),
			});
		}
		user_settings.update((settings) => {
			settings.newsletter = checked;
			return settings;
		});
	} else {
		toast.open({ type: 'danger', title: 'error_global' });
	}
};
